import FlagIcon from "@mui/icons-material/Flag";

export const JobApplicationStatusIcon = FlagIcon;
